// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Text from "../Text.bs.js";
import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.paddingBottom(BsCss.px(40)),
      tl: {
        hd: BsCss.marginTop(BsCss.px(40)),
        tl: {
          hd: BsCss.media("(min-width: 768px)", {
                hd: BsCss.width(BsCss.px(470)),
                tl: {
                  hd: BsCss.marginTop(BsCss.px(100)),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var title = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(40)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(50)),
        tl: {
          hd: BsCss.color(Theme.Color.charcoal),
          tl: {
            hd: BsCss.fontWeight("semiBold"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: {
                hd: BsCss.paddingBottom(BsCss.px(20)),
                tl: {
                  hd: BsCss.media("(max-width: 768px)", {
                        hd: BsCss.fontSize(BsCss.px(32)),
                        tl: {
                          hd: BsCss.lineHeight(BsCss.px(40)),
                          tl: {
                            hd: BsCss.paddingBottom(BsCss.px(12)),
                            tl: /* [] */0
                          }
                        }
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var subTitle = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(16)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(25)),
        tl: {
          hd: BsCss.color(Theme.Color.midGrey),
          tl: {
            hd: BsCss.fontWeight("normal"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  title: title,
  subTitle: subTitle
};

function ValueHeader(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx($$Text.make, {
                      children: "We're a team of givers, helpers & magic makers",
                      className: title
                    }),
                JsxRuntime.jsx($$Text.make, {
                      children: "Our values demonstrate how we connect the heart and the head to collectively deliver on our strategic ambitions.",
                      className: subTitle
                    })
              ],
              className: container
            });
}

var make = ValueHeader;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
